import React from "react"
import styled from "styled-components"
import {
	Container,
	Heading,
	FlexRow,
	Column,
	Link,
	ProductImage,
	ProductBrand,
	ProductTitle,
	ProductPrice,
	FullRange,
	FullRangeMobile,
	ButtonContainer,
} from "./FeaturedProducts.styles"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const responsive = {
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 3,
		slidesToSlide: 3, // optional, default to 1.
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 3,
		slidesToSlide: 2, // optional, default to 1.
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 2,
		slidesToSlide: 1, // optional, default to 1.
	},
}

export const FeaturedProducts = ({ data }) => {
	const heading = data.primary.heading[0]?.text

	const productTitle1 = data.primary.first_product?.title
	const productTitle2 = data.primary.second_product?.title
	const productTitle3 = data.primary.third_product?.title

	const productImage1 = data.primary.first_product?.image.src
	const productImage2 = data.primary.second_product?.image.src
	const productImage3 = data.primary.third_product?.image.src

	const productBrand1 = data.primary.first_product?.vendor
	const productBrand2 = data.primary.second_product?.vendor
	const productBrand3 = data.primary.third_product?.vendor

	const productPrice1 = data.primary.first_product?.variants[0].price
	const productPrice2 = data.primary.second_product?.variants[0].price
	const productPrice3 = data.primary.third_product?.variants[0].price

	const productHandle1 = data.primary.first_product?.handle
	const productHandle2 = data.primary.second_product?.handle
	const productHandle3 = data.primary.third_product?.handle

	const productLink1 = "https://milligram.com/products/" + productHandle1 + ""
	const productLink2 = "https://milligram.com/products/" + productHandle2 + ""
	const productLink3 = "https://milligram.com/products/" + productHandle3 + ""

	const shopNow = data.primary.collection_link.url
	const buttonText = data.primary.collection_button[0]?.text

	return (
		<>
			<Container>
				<Heading>{heading}</Heading>
				<FlexRow>
					{productHandle1 && (
						<Column>
							<Link href={productLink1}>
								<ProductImage src={productImage1}></ProductImage>
								<ProductBrand>{productBrand1}</ProductBrand>
								<ProductTitle>{productTitle1}</ProductTitle>
								<ProductPrice>AUD {productPrice1}</ProductPrice>
							</Link>
						</Column>
					)}
					{productHandle2 && (
						<Column>
							<Link href={productLink2}>
								<ProductImage src={productImage2}></ProductImage>
								<ProductBrand>{productBrand2}</ProductBrand>
								<ProductTitle>{productTitle2}</ProductTitle>
								<ProductPrice>AUD {productPrice2}</ProductPrice>
							</Link>
						</Column>
					)}
					{productHandle3 && (
						<Column>
							<Link href={productLink3}>
								<ProductImage src={productImage3}></ProductImage>
								<ProductBrand>{productBrand3}</ProductBrand>
								<ProductTitle>{productTitle3}</ProductTitle>
								<ProductPrice>AUD {productPrice3}</ProductPrice>
							</Link>
						</Column>
					)}
				</FlexRow>
				<ButtonContainer>
					<FullRange href={shopNow}>{buttonText}</FullRange>
				</ButtonContainer>
				<Carousel
					swipeable={true}
					draggable={true}
					showDots={false}
					responsive={responsive}
					renderArrowsWhenDisabled={true}
					partialVisible={false}
					ssr={true} // means to render carousel on server-side.
					infinite={false}
					keyBoardControl={true}
					customTransition="all .5"
					transitionDuration={500}
					containerClass="carousel-container"
					dotListClass="custom-dot-list-style"
					itemClass="carousel-item-products"
				>
					{productHandle1 && (
						<Column>
							<Link href={productLink1}>
								<ProductImage src={productImage1}></ProductImage>
								<ProductBrand>{productBrand1}</ProductBrand>
								<ProductTitle>{productTitle1}</ProductTitle>
								<ProductPrice>AUD {productPrice1}</ProductPrice>
							</Link>
						</Column>
					)}
					{productHandle2 && (
						<Column>
							<Link href={productLink2}>
								<ProductImage src={productImage2}></ProductImage>
								<ProductBrand>{productBrand2}</ProductBrand>
								<ProductTitle>{productTitle2}</ProductTitle>
								<ProductPrice>AUD {productPrice2}</ProductPrice>
							</Link>
						</Column>
					)}
					{productHandle3 && (
						<Column>
							<Link href={productLink3}>
								<ProductImage src={productImage3}></ProductImage>
								<ProductBrand>{productBrand3}</ProductBrand>
								<ProductTitle>{productTitle3}</ProductTitle>
								<ProductPrice>AUD {productPrice3}</ProductPrice>
							</Link>
						</Column>
					)}
				</Carousel>
				<ButtonContainer>
					<FullRangeMobile href={shopNow}>{buttonText}</FullRangeMobile>
				</ButtonContainer>
			</Container>
		</>
	)
}
